import { render, staticRenderFns } from "./UserTeamName.vue?vue&type=template&id=4ae245ac&"
import script from "./UserTeamName.vue?vue&type=script&lang=js&"
export * from "./UserTeamName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports